var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveFlowStatef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29047 16.7567V10.8919C1.29047 10.4684 1.80326 10.2101 2.16317 10.4334C3.32808 11.156 5.57152 12.2665 8.35724 12.2665C11.1535 12.2665 13.2171 11.2462 14.3263 10.5252C14.6945 10.2859 15.2535 10.551 15.2535 10.9901V16.7814C15.2535 16.958 15.2078 17.1305 15.0985 17.2692C14.5905 17.9137 12.7495 19.7644 8.35724 19.7644C3.99382 19.7644 2.03342 17.9379 1.47011 17.282C1.34494 17.1363 1.29047 16.9488 1.29047 16.7567Z",
    fill: "#87DDB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3931 8.06299L12 10.4561L9.60688 8.06299",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 2.99996L12 10.456",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62961 8.8833C5.75266 9.35882 5.23132 9.95413 5.23132 10.6002C5.23132 12.1578 8.26177 13.4205 12 13.4205C15.7383 13.4205 18.7687 12.1578 18.7687 10.6002C18.7687 9.95413 18.2474 9.35882 17.3704 8.8833",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7687 14.4253C18.7687 15.9829 15.7383 17.2456 12 17.2456C8.26177 17.2456 5.23132 15.9829 5.23132 14.4253",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23132 10.5093L5.23132 18.3258C5.23132 19.8834 8.26177 21.1461 12 21.1461C15.7383 21.1461 18.7687 19.8834 18.7687 18.3258V10.5093",
    stroke: "#272932",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFlowStatef);
export default __webpack_public_path__ + "static/media/Save Flow State f.5694ee3b367a44af92e081006f42363c.svg";
export { ForwardRef as ReactComponent };